<template lang="pug">
modal(v-if="usuario" :max-width="1200")
	.card
		.card-header.bg-info.text-white
			|Editor de usuario
			button.close(type="button" aria-label="Close" @click="cerrar")
				span(aria-hidden="true") &times;
		.card-body.pt-0.row.pb-0
			.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4.bg-light.text-center.p-4(style="border-right: 1px solid #e0e0e0;")
				img.rounded-circle(:src="avatar" alt="avatar" style="width:90px;height:90px;")
				br
				button.btn.btn-sm.btn-primary.mt-3(@click="nuevoAvatar = true")
					span.fa.fa-photo.mr-2
					|Cambiar
				hr
				.text-left
					h5 Datos personales
					.form-group
						label 
							b Nombre
						input.form-control(type="text" v-model="usuario.nombre" placeholder="Nombre" required)
					.form-group
						label 
							b Apellidos
						input.form-control(type="text" v-model="usuario.apellidos" placeholder="Apellidos" required)
					.form-group
						label 
							b DNI
						input.form-control(type="text" v-model="usuario.DNI" placeholder="12345678A" required)
					.form-group
						label 
							b Fecha de nacimiento
						datepicker(
							:monday-first="true"
							:language='$dateLang'
							v-model="usuario.fecha_nacimiento"
							format="dd-MM-yyyy"
							:bootstrap-styling="true"
							placeholder="DD-MM-YYYY")
					.form-group
						label 
							b Género
						br
						.btn-group
							button.btn.btn-sm(:class="(usuario.sexo === 'hombre') ? 'btn-primary' : 'btn-default'" @click="usuario.sexo = 'hombre'")
								|Hombre
							button.btn.btn-sm(:class="(usuario.sexo === 'mujer') ? 'btn-primary' : 'btn-default'" @click="usuario.sexo = 'mujer'")
								|Mujer
							button.btn.btn-sm(:class="(usuario.sexo === 'otro') ? 'btn-primary' : 'btn-default'" @click="usuario.sexo = 'otro'")
								|Otro
					.form-group
						label 
							b Empresa
						select.form-control(v-model="usuario.empresa_ID")
							option(:value="null" disabled) Selecciona
							option(v-for="empresa in listadoEmpresas" :key="empresa.ID_empresa" :value="empresa.ID_empresa") {{empresa.NombreFiscal}}
					.form-group
						label 
							b Categoría
						select.form-control(v-model="usuario.tipo")
							option(:value="null" disabled) Selecciona
							option(v-for="cat in listadoCategorias" :key="cat" :value="cat") {{ cat }}
			.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8.text-left.p-4
				ul.nav.nav-tabs.mt-1.mb-3
					li.nav-item
						a.nav-link(style="cursor:pointer" :class="(seccion === 'general') ? 'active' : ''" @click="seccion = 'general'")
							span.fa.fa-info-circle.fa-w.mr-2
							|General
					li.nav-item
						a.nav-link(style="cursor:pointer" :class="(seccion === 'emails') ? 'active' : ''" @click="seccion = 'emails'")
							span.fa.fa-envelope.fa-w.mr-2
							|Emails
					li.nav-item
						a.nav-link(style="cursor:pointer" :class="(seccion === 'extras') ? 'active' : ''" @click="seccion = 'extras'")
							span.fa.fa-w.fa-star.mr-2
							|Extras
					// li.nav-item(v-if="usuario.ID !== null && ldap")
						a.nav-link(style="cursor:pointer" :class="(seccion === 'unix') ? 'active' : ''" @click="seccion = 'unix'")
							span.fa.fa-w.mr-2.fa-linux
							|Linux
					// li.nav-item(v-if="usuario.ID !== null && ldap")
						a.nav-link(style="cursor:pointer" :class="(seccion === 'samba') ? 'active' : ''" @click="seccion = 'samba'")
							span.fa.fa-w.fa-windows.mr-2
							|Samba
					li.nav-item(v-if="usuario.ID")
						a.nav-link(style="cursor:pointer" :class="(seccion === 'horario') ? 'active' : ''" @click="seccion = 'horario'")
							span.fa.fa-w.fa-calendar.mr-2
							|Horario
				usuario-extras(:usuario.sync="usuario" v-if="seccion === 'extras'")
				emails(:usuario="usuario" v-if="seccion === 'emails'")
				general(v-if="seccion === 'general'" :usuario.sync="usuario")
				// general(v-if="seccion === 'general'" :usuario.sync="usuario" :ldap.sync="ldap")
				// datos-unix(v-if="seccion === 'unix'" :usuario="usuario" :ldap="ldap")
				// samba(v-if="seccion === 'samba'" :usuario="usuario" :ldap="ldap")
				horario(v-if="seccion === 'horario'" :usuario="usuario")
	crop-avatar(v-if="nuevoAvatar" @cerrar="nuevoAvatar = false" @img="setNuevoAvatar($event)")
</template>

<style>
.form-group .vdp-datepicker .input-group > input {
	background-color: white !important;
}
</style>

<script>
import API from '../api'
import General from './general'
// import Unix from './unix'
// import Samba from './samba'
import Extras from './extras'
import Horario from './horario'
import Emails from './emails'
import CropAvatar from './crop-avatar'

export default {
	props: ['idusuario'],
	components: {
		'general': General,
		// 'datos-unix': Unix,
		// 'samba': Samba,
		'usuario-extras': Extras,
		'emails': Emails,
		'crop-avatar': CropAvatar,
		'horario': Horario
	},
	data () {
		return {
			usuario: null,
			// ldap: null,
			seccion: 'general',
			nuevoAvatar: false,
			listadoEmpresas: [],
			listadoCategorias: ['Empleado', 'Prácticas', 'Colaborador']
		}
	},

	created () {
		if (this.idusuario === 'nuevo') {
			this.nuevo()
		} else {
			this.getUsuario()
		}

		API.getEmpresas()
			.then(res => {
				this.listadoEmpresas = res.data
			})
			.catch(this.$responseError)
	},

	computed: {
		avatar () {
			if (!this.usuario.avatar) {
				return '/static/recursos/' + this.usuario.sexo + '.svg'
			} else {
				return this.usuario.avatar
			}
		}
	},

	methods: {
		nuevo () {
			this.usuario = {
				ID: null,
				usuario: '',
				nombre: '',
				DNI: null,
				empresa_ID: null,
				tipo: null,
				apellidos: '',
				sexo: 'otro',
				nacimiento: null,
				telefono: '',
				email: '',
				// ldap: null,
				caduca_password: null,
				otps: null,
				fecha_expiracion_cuenta: null,
				extras: [],
				password: '',
				periodo_password: 45,
				horario: []
			}
			// this.ldap = null
		},
		getUsuario () {
			API.get(this.idusuario)
				.then(res => {
					res.data.usuario.fecha_nacimiento = (res.data.usuario.fecha_nacimiento) ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null
					res.data.usuario.caduca_password = (res.data.usuario.caduca_password) ? new Date(res.data.usuario.caduca_password * 1000) : null
					res.data.usuario.fecha_expiracion_cuenta = (res.data.usuario.fecha_expiracion_cuenta) ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null

					this.usuario = res.data.usuario
					// this.ldap = (res.data.ldap) ? res.data.ldap : null
				})
				.catch(e => {
					console.log(e)
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		setNuevoAvatar (img) {
			this.usuario.avatar = img
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-usuarios/vue/editor/editor.vue